function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { formatAsCurrency } from 'utilities/currency';
import { formatDate, formatTime } from 'utilities/date';
import * as S from './Table.styles';
const Table = /*#__PURE__*/React.forwardRef(({
  children,
  data
}, ref) => {
  const renderDeclarativeTable = () => {
    // This is just to avoid the repeated use of optional chaining. This method is only called when data is defined
    if (!data) {
      return null;
    }
    const {
      headers,
      rows
    } = data;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement(TableRow, null, headers.map(({
      children,
      ...props
    }, i) => /*#__PURE__*/React.createElement(TableHeader, _extends({
      key: i
    }, props), children)))), /*#__PURE__*/React.createElement("tbody", null, rows.map((cells, i) => {
      return /*#__PURE__*/React.createElement(TableRow, {
        key: i
      }, cells.map((cellProps, i) => /*#__PURE__*/React.createElement(TableCell, _extends({
        key: i
      }, cellProps))));
    })));
  };
  return /*#__PURE__*/React.createElement(S.StyledTableContainer, null, /*#__PURE__*/React.createElement(S.StyledTable, {
    ref: ref
  }, children ?? renderDeclarativeTable()));
});
const TableRow = /*#__PURE__*/React.forwardRef(({
  children,
  onClick,
  id
}, ref) => {
  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };
  return /*#__PURE__*/React.createElement(S.StyledTableRow, {
    ref: ref,
    onClick: handleClick,
    id: id
  }, children);
});
const TableHeader = /*#__PURE__*/React.forwardRef(({
  children,
  type
}, ref) => {
  return /*#__PURE__*/React.createElement(S.StyledTableHeader, {
    ref: ref,
    $type: type
  }, children);
});
const TableCell = /*#__PURE__*/React.forwardRef(({
  children,
  type,
  content,
  onClick,
  id,
  isWrapped = false
}, ref) => {
  const renderContent = () => {
    if (children) {
      return children;
    }
    switch (type) {
      case 'currency':
        {
          return formatAsCurrency(content);
        }
      case 'date':
        {
          return formatDate({
            date: content
          });
        }
      case 'time':
        {
          return formatTime({
            date: content
          });
        }
      case 'text':
        {
          return children;
        }
      default:
        return null;
    }
  };
  const handleClick = e => {
    if (onClick) {
      e.stopPropagation();
      onClick(id);
    }
  };
  return /*#__PURE__*/React.createElement(S.StyledTableCell, {
    ref: ref,
    onClick: handleClick,
    $isWrapped: isWrapped,
    $type: type
  }, renderContent());
});
export { Table, TableRow, TableHeader, TableCell };